export default defineNuxtRouteMiddleware((to) => {
  const name = to.meta?.resourceName
  if (name && !useCan(`${name}.view`)) {
    return navigateTo('/403')
  }
})
